export const en = {
  invoice: 'Invoice',
  details: 'Details',
  to: 'To',
  invoiceStatus: 'Invoice status',
  dueDate: 'Due date',
  summary: 'Summary',
  subTotal: 'Subtotal',
  discount: 'Discount',
  tax: 'Tax',
  paymentDetails: 'Bank Transfer Details',
  payWithCrypto: 'Pay with cryptocurrency (ERC-20)',
  sendToAddress: 'Send to address',
  bank: 'Bank Name',
  branch: 'Branch',
  account: 'Account Number',
  iban: 'IBAN',
  net: 'Net',
  total: 'Total',
  address: 'Address',
  routing: 'Routing/ABA',
  swift: 'SWIFT',
  issueDate: 'Issue date',
  billingPeriod: 'Billing period',
  dueUponReceipt: 'Due upon receipt',
  dueUponUsage: 'Due upon usage',
  billTo: 'Bill To',
  payTo: 'Pay To',
  partial: 'Partial',
  invoiceNo: 'Invoice NO.',
  payoutNo: 'Payout NO.',
  draft: 'Draft',
  start: 'Start',
  period: 'Period',
  qty: 'Qty.',
  enddate: 'End date',
  subActivity: 'Sub activity',
  usageReport: 'Usage Reports',
  attachYourLogo: 'Attach Your Logo',
  totalDue: 'Total Due',
  productName: 'Product Name',
  amount: 'Amount',
  creditNotePreview: 'Credit Note Preview',
  creditTo: 'Credit To',
  creditNoteNo: 'Credit Note NO.',
  createdOn: 'Created On',
  reasonCode: 'Reason Code',
  totalCredits: 'Total Credits',
  poweredBy: 'Powered By',
  received: 'Stigg',
  creditBalance: 'Credits Balance',
  note: 'Note',
  relatedInvoice: 'Related Invoice',
  with: 'with',
  previousCreditsPaid: 'Previous Paid Credits',
  currentCreditsPaid: 'Paid Credits',
  credits: 'Credits',
  creditNote: 'Credit Note',
  paidCredits: 'Paid Credits',
  creditPeriod: 'Credit Period',
  Draft: 'DRAFT-',
  entityDetails: 'Entity Details',
  companyName: 'Company Name',
  companyEIN: 'Company Number (EIN)',
  contactInformation: 'Contact Information',
  registeredAddress: 'Registered Address',
  debit: 'Debit Note',
  debitNo: 'Debit Note NO.',
  type: 'Type',
  logs: 'Logs',
  sample: 'SAMPLE',
  additionalLogsForThisProduct: 'additional logs for this product will be displayed when downloading the PDF.',
  payWithCreditCard: 'Pay with credit card',
  paid: 'Paid',
  unPaid: 'Unpaid',
  canceled: 'Canceled',
  readyToSend: 'Ready to send',
  missingInfo: 'Missing info',
  minimumFee: 'Minimum Fee',
  bankCode: 'Bank Code',
  payout: 'Payout',
  payoutDate: 'Payout date',
};
